// extracted by mini-css-extract-plugin
export default {"actionButtons":"confirmSaveSakDialog_actionButtons__mZJIx"};